package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_03_29_Day_1
import com.veldekar.components.logs.Log_2025_03_29_Day_2
import com.veldekar.components.logs.Log_2025_03_29_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-03-29")
@Composable
public fun Log_2025_03_29(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Anomalation!",
        ogTitle = "Anomalation!",
        date = LocalDate(2_025, 3, 29),
        ogDescription = "Veldekar is lousy with Slaad. And they smell funny.",
        ogImage = "images/flags1.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A collection of five different flags from Veldekar designs or banners on a black background.",
    ) {
        SessionDayHeader(dayId = "newgrowth-83", dateString = "Newgrowth 83")
        Log_2025_03_29_Day_1()
        SessionDayHeader(dayId = "newgrowth-84", dateString = "Newgrowth 84")
        Log_2025_03_29_Day_2()
        SessionDayHeader(dayId = "newgrowth-85", dateString = "Newgrowth 85")
        Log_2025_03_29_Day_3()
    }
}
